let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("elG2c")).then(() => parcelRequire('3iOYF'));